module.exports = __webpack_public_path__ + "soap-icons.7351b5d5f8f144235fd7.woff";


//////////////////
// WEBPACK FOOTER
// D:/ptrans/front-end-customer/src/assets/fonts/soap-icons.woff?26664784
// module id = ../../../../../src/assets/fonts/soap-icons.woff?26664784
// module chunks = 2